"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileUpload = useFileUpload;
var react_1 = require("react");
var file_1 = require("../constants/file");
var file_2 = require("../features/apis/file");
var hooks_1 = require("../store/hooks");
var api_error_message_1 = require("../utils/api-error-message");
var discarded_upload_cleanup_1 = require("../utils/discarded-upload-cleanup");
var prepare_image_for_upload_1 = require("../utils/prepare-image-for-upload");
var upload_to_signed_url_1 = require("../utils/upload-to-signed-url");
/**
 * Validates a picked file, starts the upload with the API and streams it to the bucket. The pending record it
 * returns is not applied anywhere until the caller completes it; until the caller reports that through
 * markActivated, any reset, replacement or unmount deletes the record and its bucket object again.
 */
function useFileUpload(ownerType, ownerId, category) {
    var _this = this;
    var startUpload = (0, file_2.useStartUploadMutation)()[0];
    var dispatch = (0, hooks_1.useAppDispatch)();
    var _a = (0, react_1.useState)("idle"), status = _a[0], setStatus = _a[1];
    var _b = (0, react_1.useState)(0), progress = _b[0], setProgress = _b[1];
    var _c = (0, react_1.useState)(null), pendingFile = _c[0], setPendingFile = _c[1];
    var _d = (0, react_1.useState)(""), error = _d[0], setError = _d[1];
    // Bumped on reset and unmount so a response from an earlier pick never lands after the caller moved on.
    var requestTokenRef = (0, react_1.useRef)(0);
    var uploadHandleRef = (0, react_1.useRef)(null);
    // The API record created for the current pick that nobody has activated yet.
    var discardableFileIdRef = (0, react_1.useRef)(null);
    var discardCurrentRecord = function () {
        var fileId = discardableFileIdRef.current;
        discardableFileIdRef.current = null;
        if (fileId)
            (0, discarded_upload_cleanup_1.discardUploadRecord)(dispatch, fileId);
    };
    (0, react_1.useEffect)(function () { return function () {
        var _a;
        requestTokenRef.current += 1;
        (_a = uploadHandleRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        discardCurrentRecord();
    }; }, []);
    var reset = function () {
        var _a;
        requestTokenRef.current += 1;
        (_a = uploadHandleRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        uploadHandleRef.current = null;
        discardCurrentRecord();
        setStatus("idle");
        setProgress(0);
        setPendingFile(null);
        setError("");
    };
    var markActivated = function () {
        discardableFileIdRef.current = null;
    };
    var selectFile = function (file) { return __awaiter(_this, void 0, void 0, function () {
        var rule, requestToken, upload, _a, response, handle, uploadError_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    rule = file_1.FILE_CATEGORY_RULES[category];
                    // Clear any earlier pick first so a rejected file never leaves a stale pending record behind.
                    reset();
                    if (!rule.acceptedTypes.includes(file.type)) {
                        setError("Please choose a ".concat(rule.acceptedTypes.map(function (type) { return type.split("/")[1].toUpperCase(); }).join(", "), " file."));
                        setStatus("error");
                        return [2 /*return*/];
                    }
                    if (file.size > rule.maxSize) {
                        setError("".concat(rule.label, " must be ").concat(Math.floor(rule.maxSize / file_1.MEGABYTE), " MB or smaller."));
                        setStatus("error");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    setStatus("uploading");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 7, , 8]);
                    if (!rule.resize) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, prepare_image_for_upload_1.prepareImageForUpload)(file, rule.resize)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = file;
                    _b.label = 4;
                case 4:
                    upload = _a;
                    if (requestToken !== requestTokenRef.current)
                        return [2 /*return*/];
                    return [4 /*yield*/, startUpload({
                            owner_type: ownerType,
                            owner_id: ownerId,
                            category: category,
                            original_name: upload.name,
                            content_type: upload.type,
                            size: upload.size,
                        }).unwrap()];
                case 5:
                    response = _b.sent();
                    // The caller moved on while the API was creating the record, so nothing else will ever clean it up.
                    if (requestToken !== requestTokenRef.current) {
                        (0, discarded_upload_cleanup_1.discardUploadRecord)(dispatch, response.content.file.id);
                        return [2 /*return*/];
                    }
                    discardableFileIdRef.current = response.content.file.id;
                    handle = (0, upload_to_signed_url_1.uploadToSignedUrl)({
                        url: response.content.upload_url,
                        headers: response.content.headers,
                        file: upload,
                        onProgress: function (percent) {
                            if (requestToken === requestTokenRef.current)
                                setProgress(percent);
                        },
                    });
                    uploadHandleRef.current = handle;
                    return [4 /*yield*/, handle.promise];
                case 6:
                    _b.sent();
                    if (requestToken !== requestTokenRef.current)
                        return [2 /*return*/];
                    uploadHandleRef.current = null;
                    setPendingFile(response.content.file);
                    setStatus("ready");
                    return [3 /*break*/, 8];
                case 7:
                    uploadError_1 = _b.sent();
                    if (requestToken !== requestTokenRef.current)
                        return [2 /*return*/];
                    uploadHandleRef.current = null;
                    discardCurrentRecord();
                    setError(uploadError_1 instanceof Error ? uploadError_1.message : (0, api_error_message_1.getApiErrorMessage)(uploadError_1, "The upload failed. Please try again."));
                    setStatus("error");
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return { selectFile: selectFile, progress: progress, status: status, pendingFile: pendingFile, error: error, reset: reset, markActivated: markActivated };
}
